import { useCallback } from 'react';
import { produce } from 'immer';

import useUser from '@/hooks/useUser';

export function useSelectedWatchlist() {
  const {
    data: user,
    isFetched: userIsFetched,
    mutate: updateUserSettings,
    setQueryData: setUserSettings,
  } = useUser();

  const watchlistId = userIsFetched ? user.defaultWatchlistId : undefined;

  const selectWatchlist = useCallback(
    (id: string | null) => {
      setUserSettings((state) =>
        produce(state, (draft) => {
          draft.defaultWatchlistId = id;
        })
      );

      updateUserSettings({
        settings: {
          default_watchlist_id: id,
        },
      });
    },
    [setUserSettings, updateUserSettings]
  );

  return [watchlistId, selectWatchlist] as const;
}
